import { keyLabel } from '@/lib/hotkeys';
import { cn } from '@/lib/utils';

/** A key combo as <kbd> chips ("mod+k" → Ctrl K / ⌘ K), for tooltips, hints and the cheat-sheet. */
export function Keys({ combo, className }: { combo: string; className?: string }) {
  return (
    <span className={cn('inline-flex gap-0.5', className)}>
      {keyLabel(combo).map((k) => (
        <kbd key={k}>{k}</kbd>
      ))}
    </span>
  );
}
